import { useEffect } from "react"

export const unsetFocus = () => {
  setTimeout(() => {
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur()
  }, 1)
}

export const useUnsetFocus = (val: boolean) =>
  useEffect(() => {
    if (val) unsetFocus()
  }, [val])
